export default __webpack_public_path__ + "static/media/PCGC_Login_logo.c7b1a0c6.png";